// convert { a: true, b: false, c: true } => ['a', 'c']
export function checkSelectValues(obj: Record<string, boolean | null | undefined> | null): string[] {
  if (!obj) {
    return [];
  }
  return Object.keys(obj).filter(key => !!obj[key]);
}
